/**
 * Variáveis de cor da conversa do WhatsApp (`--wa-*`), claro e escuro. O telefone e o cartão de
 * envio as aplicam no elemento da conversa; o `MessageBubble` só lê as variáveis.
 */

export const CHAT_THEMES = {
  light: {
    "--wa-bg": "#efeae2",
    "--wa-head": "#f0f2f5",
    "--wa-head-fg": "#111b21",
    "--wa-sub": "#667781",
    "--wa-in": "#ffffff",
    "--wa-in-fg": "#111b21",
    "--wa-out": "#d9fdd3",
    "--wa-link": "#027eb5",
    "--wa-meta": "#667781",
    "--wa-input": "#ffffff",
    "--wa-chip": "rgba(255,255,255,0.85)",
    "--wa-doodle": "rgba(11,20,26,0.045)",
    "--wa-bar": "#111b21",
    "--wa-var-bg": "#d7ecf3",
    "--wa-var-fg": "#0b5d75",
  },
  dark: {
    "--wa-bg": "#0b141a",
    "--wa-head": "#202c33",
    "--wa-head-fg": "#e9edef",
    "--wa-sub": "#8696a0",
    "--wa-in": "#202c33",
    "--wa-in-fg": "#e9edef",
    "--wa-out": "#005c4b",
    "--wa-link": "#53bdeb",
    "--wa-meta": "#8696a0",
    "--wa-input": "#202c33",
    "--wa-chip": "rgba(24,34,41,0.85)",
    "--wa-doodle": "rgba(255,255,255,0.035)",
    "--wa-bar": "#ffffff",
    "--wa-var-bg": "#12485a",
    "--wa-var-fg": "#9fe0f3",
  },
};

/** O fundo pontilhado da conversa, igual ao do telefone. */
export const CHAT_BACKGROUND = {
  backgroundColor: "var(--wa-bg)",
  backgroundImage: "radial-gradient(var(--wa-doodle) 1.2px, transparent 1.4px), radial-gradient(var(--wa-doodle) 1.2px, transparent 1.4px)",
  backgroundSize: "22px 22px",
  backgroundPosition: "0 0, 11px 11px",
};
